module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4wZ6i"))).then(() => parcelRequire('jOLV9'));